import { EngagementIntent } from '@/types/enterprise';

export const ENGAGEMENT_INTENT_LABEL = {
  [EngagementIntent.ImmediateSearch]: '直ぐに案件を探している',
  [EngagementIntent.ActivelySearching]: '案件を探している',
  [EngagementIntent.ConsideringIfGood]: 'いい案件があったら検討したい',
  [EngagementIntent.ExploringOptions]: '情報収集や案件を探すきっかけとして面談したい',
  [EngagementIntent.StatusQuoPreferred]: '現状維持が濃厚',
} as const;

export const ENGAGEMENT_INTENT_OPTIONS = Object.entries(ENGAGEMENT_INTENT_LABEL).map(([value, label]) => ({
  value,
  label,
})) as { value: EngagementIntent; label: string }[];

// REST API (apps/server) の FullTimeSwitchIntent enum に対応するローカル定義。
// GraphQL は使用していないため gql 生成型には依存しない。
export const FullTimeSwitchIntent = {
  Interested: 'INTERESTED',
  Considering: 'CONSIDERING',
  NotInterested: 'NOT_INTERESTED',
} as const;

export type FullTimeSwitchIntent = (typeof FullTimeSwitchIntent)[keyof typeof FullTimeSwitchIntent];

const FULL_TIME_SWITCH_INTENT_VALUES: readonly string[] = Object.values(FullTimeSwitchIntent);

export const isFullTimeSwitchIntent = (value: string): value is FullTimeSwitchIntent =>
  FULL_TIME_SWITCH_INTENT_VALUES.includes(value);

/** URLクエリのカンマ区切りを配列にする。未知の値は捨てる。 */
export const parseFullTimeSwitchIntents = (value: string | undefined): FullTimeSwitchIntent[] =>
  value?.split(',').filter(isFullTimeSwitchIntent) ?? [];

export const FULL_TIME_SWITCH_INTENT_LABEL = {
  [FullTimeSwitchIntent.Interested]: '正社員切り替え意向あり',
  [FullTimeSwitchIntent.Considering]: '条件次第で正社員切り替えを検討',
  [FullTimeSwitchIntent.NotInterested]: '正社員切り替え意向なし',
} as const;
